import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumEcommerceConnectionStatus implements BaseEnumType {
  private static allValues: EnumEcommerceConnectionStatus[] = []; // make sure this is top-most
  
  public static pendingAuthorisation = new EnumEcommerceConnectionStatus(0, "PendingAuthorisation", "enum_ecommerce_connection_status_pending_authorisation");
  public static connected = new EnumEcommerceConnectionStatus(1, "Connected", "enum_ecommerce_connection_status_connected");
  public static disconnected = new EnumEcommerceConnectionStatus(2, "Disconnected", "enum_ecommerce_connection_status_disconnected");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumEcommerceConnectionStatus.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isPendingAuthorisation() { return this === EnumEcommerceConnectionStatus.pendingAuthorisation; }
  public isConnected() { return this === EnumEcommerceConnectionStatus.connected; }
  public isDisconnected() { return this === EnumEcommerceConnectionStatus.disconnected; }

  public static getValues(): readonly EnumEcommerceConnectionStatus[] {
    return EnumEcommerceConnectionStatus.allValues;
  }

  public static getValuesExcept0(): readonly EnumEcommerceConnectionStatus[] {
    return EnumEcommerceConnectionStatus.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumEcommerceConnectionStatus {
    const found = EnumEcommerceConnectionStatus.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumEcommerceConnectionStatus - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumEcommerceConnectionStatus): EnumEcommerceConnectionStatus {
    const found = name ? EnumEcommerceConnectionStatus.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumEcommerceConnectionStatus - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumEcommerceConnectionStatus>): boolean {
    return this.key === other?.key;
  }
}